import { Component } from '@theme/component'
import { QuantitySelectorUpdateEvent } from '@theme/events'

class UiQuantitySelector extends Component {
  requiredRefs = ['quantityInput']

  #checkQuantityRules = () => {
    const { quantityInput } = this.refs
    const { min, max, value: newValue } = quantityInput

    if (newValue < min && min) quantityInput.value = min
    if (newValue > max && max) quantityInput.value = max
  }

  increaseQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return

    event.preventDefault()
    this.refs.quantityInput.stepUp()
    this.#onQuantityChange()
  }

  decreaseQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return

    event.preventDefault()
    this.refs.quantityInput.stepDown()
    this.#onQuantityChange()
  }

  selectInputValue(event) {
    const { quantityInput } = this.refs
    if (
      !(event.target instanceof HTMLInputElement) ||
      document.activeElement !== quantityInput
    )
      return

    quantityInput.select()
  }

  setQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return

    event.preventDefault()
    if (event.target instanceof HTMLInputElement) {
      this.refs.quantityInput.value = event.target.value
    }
    this.#onQuantityChange()
  }

  #onQuantityChange() {
    const { quantityInput } = this.refs

    this.#checkQuantityRules()
    const newValue = Number.parseInt(quantityInput.value, 10)

    quantityInput.dispatchEvent(
      new QuantitySelectorUpdateEvent(
        newValue,
        Number(quantityInput.dataset.cartLine)
      )
    )
  }
}

if (!customElements.get('quantity-selector')) {
  customElements.define('quantity-selector', UiQuantitySelector)
}
